import * as React from 'react';
import { TourModal } from '../../components/TourModal';
import { useSelector } from 'react-redux';
import { selectBuilder, selectPrice, selectProjectName, selectTour } from '../../selectors';
import { PhoneButtonContainer } from '../PhoneButtonContainer';
import { Button } from '@cian/ui-kit';
import { SidebarContactsInfo } from '../../components/SidebarContactsInfo';
import { CallbackContainer } from '../CallbackContainer';
import { ECallbackWidgetPlacement } from '../../types/callbackWidget';

interface ITourModalContainerProps {
  onClose(): void;
}

export const TourModalContainer: React.FC<ITourModalContainerProps> = ({ onClose }) => {
  const tour = useSelector(selectTour);
  const projectName = useSelector(selectProjectName);
  const { startPrice, endPrice } = useSelector(selectPrice);
  const builder = useSelector(selectBuilder);

  if (!tour) {
    return null;
  }

  return (
    <TourModal
      tourUrl={tour.url}
      project={{ name: projectName, startPrice, endPrice }}
      builder={builder}
      contactsButton={
        <PhoneButtonContainer
          button={<Button fullWidth>Контакты застройщика</Button>}
          contentRenderer={phone => <SidebarContactsInfo phone={phone} />}
        />
      }
      callbackButton={<CallbackContainer placement={ECallbackWidgetPlacement.Tour} />}
      onClose={onClose}
    />
  );
};
